import * as React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    DateField,
} from 'react-admin';
import { Card, CardContent, Typography } from '@mui/material';

export default function ContactMessageShow(props) {
    return (
        <Show {...props}>
            <SimpleShowLayout>
                <TextField source="id" label="ID" />
                <DateField source="createdAt" label="Reçu le" showTime />
                <TextField source="email" label="Expéditeur" />
                <TextField source="reason" label="Motif" />
                <Card
                    variant="outlined"
                    sx={{ mt: 2, backgroundColor: '#f8fafc', borderRadius: 2 }}
                >
                    <CardContent>
                        <Typography variant="overline" color="text.secondary">
                            Message
                        </Typography>
                        <TextField
                            source="message"
                            sx={{
                                mt: 1,
                                whiteSpace: 'pre-wrap',
                                display: 'block',
                                color: 'text.primary',
                            }}
                        />
                    </CardContent>
                </Card>
            </SimpleShowLayout>
        </Show>
    );
}
